import { ApiDataSourceSpec, apiDataSource } from "@/io/datasource/ApiDatasource.ts";
import { MedicalTeamNote, medicalTeamNoteSchema } from "@/models/MedicalTeamNote.ts";
import { cz } from "@/utils/zodUtils.ts";

export class NotesRepository {
  constructor(private readonly datasource: ApiDataSourceSpec = apiDataSource) {}

  getNote = async (patientId: string): Promise<MedicalTeamNote> =>
    this.datasource.get(
      `practitioner/medical-note/${patientId}/`,
      cz.transform(
        cz.noContent(medicalTeamNoteSchema),
        note =>
          note ?? {
            content: undefined,
          },
      ),
    );

  writeNote = (patientId: string, content: string | undefined) => {
    return this.datasource.post(`practitioner/medical-note/${patientId}/`, cz.ignore(), {
      content,
    });
  };
}
